import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

/** From `public/images/Dashboard.svg` — currentColor for active NavLink */
const DashboardIcon = ({ className = 'w-4 h-4 shrink-0' }) => (
  <svg className={className} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M5 0H1.25C0.918479 0 0.600537 0.131696 0.366116 0.366116C0.131696 0.600537 0 0.918479 0 1.25V5C0 5.33152 0.131696 5.64946 0.366116 5.88388C0.600537 6.1183 0.918479 6.25 1.25 6.25H5C5.33152 6.25 5.64946 6.1183 5.88388 5.88388C6.1183 5.64946 6.25 5.33152 6.25 5V1.25C6.25 0.918479 6.1183 0.600537 5.88388 0.366116C5.64946 0.131696 5.33152 0 5 0ZM5 5H1.25V1.25H5V5ZM12.5 0H8.75C8.41848 0 8.10054 0.131696 7.86612 0.366116C7.6317 0.600537 7.5 0.918479 7.5 1.25V5C7.5 5.33152 7.6317 5.64946 7.86612 5.88388C8.10054 6.1183 8.41848 6.25 8.75 6.25H12.5C12.8315 6.25 13.1495 6.1183 13.3839 5.88388C13.6183 5.64946 13.75 5.33152 13.75 5V1.25C13.75 0.918479 13.6183 0.600537 13.3839 0.366116C13.1495 0.131696 12.8315 0 12.5 0ZM12.5 5H8.75V1.25H12.5V5ZM5 7.5H1.25C0.918479 7.5 0.600537 7.6317 0.366116 7.86612C0.131696 8.10054 0 8.41848 0 8.75V12.5C0 12.8315 0.131696 13.1495 0.366116 13.3839C0.600537 13.6183 0.918479 13.75 1.25 13.75H5C5.33152 13.75 5.64946 13.6183 5.88388 13.3839C6.1183 13.1495 6.25 12.8315 6.25 12.5V8.75C6.25 8.41848 6.1183 8.10054 5.88388 7.86612C5.64946 7.6317 5.33152 7.5 5 7.5ZM5 12.5H1.25V8.75H5V12.5ZM12.5 7.5H8.75C8.41848 7.5 8.10054 7.6317 7.86612 7.86612C7.6317 8.10054 7.5 8.41848 7.5 8.75V12.5C7.5 12.8315 7.6317 13.1495 7.86612 13.3839C8.10054 13.6183 8.41848 13.75 8.75 13.75H12.5C12.8315 13.75 13.1495 13.6183 13.3839 13.3839C13.6183 13.1495 13.75 12.8315 13.75 12.5V8.75C13.75 8.41848 13.6183 8.10054 13.3839 7.86612C13.1495 7.6317 12.8315 7.5 12.5 7.5ZM12.5 12.5H8.75V8.75H12.5V12.5Z"
      fill="currentColor"
    />
  </svg>
);

/** From `public/images/Instructor.svg` */
const InstructorIcon = ({ className = 'w-4 h-4 shrink-0' }) => (
  <svg className={className} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M16.1735 14.6896C14.9836 12.6326 13.15 11.1576 11.0102 10.4584C12.0686 9.82826 12.891 8.86812 13.351 7.7254C13.8109 6.58268 13.8831 5.32056 13.5563 4.13287C13.2296 2.94518 12.522 1.89759 11.5422 1.15097C10.5624 0.404356 9.36466 0 8.13284 0C6.90102 0 5.70325 0.404356 4.72349 1.15097C3.74372 1.89759 3.03612 2.94518 2.70936 4.13287C2.3826 5.32056 2.45474 6.58268 2.91471 7.7254C3.37467 8.86812 4.19703 9.82826 5.2555 10.4584C3.11565 11.1568 1.28206 12.6318 0.0922159 14.6896C0.0485822 14.7608 0.0196403 14.8399 0.0070978 14.9225C-0.00544473 15.005 -0.00133381 15.0892 0.019188 15.1701C0.0397098 15.251 0.0762269 15.3269 0.126585 15.3935C0.176942 15.46 0.24012 15.5158 0.312392 15.5576C0.384663 15.5993 0.464563 15.6262 0.547378 15.6365C0.630193 15.6469 0.714246 15.6406 0.794576 15.6179C0.874907 15.5953 0.949888 15.5568 1.0151 15.5047C1.08031 15.4526 1.13442 15.388 1.17425 15.3146C2.64612 12.7709 5.24768 11.2521 8.13284 11.2521C11.018 11.2521 13.6196 12.7709 15.0914 15.3146C15.1313 15.388 15.1854 15.4526 15.2506 15.5047C15.3158 15.5568 15.3908 15.5953 15.4711 15.6179C15.5514 15.6406 15.6355 15.6469 15.7183 15.6365C15.8011 15.6262 15.881 15.5993 15.9533 15.5576C16.0256 15.5158 16.0887 15.46 16.1391 15.3935C16.1895 15.3269 16.226 15.251 16.2465 15.1701C16.267 15.0892 16.2711 15.005 16.2586 14.9225C16.246 14.8399 16.2171 14.7608 16.1735 14.6896ZM3.75784 5.62713C3.75784 4.76183 4.01443 3.91597 4.49516 3.19651C4.97589 2.47704 5.65917 1.91629 6.4586 1.58515C7.25803 1.25402 8.13769 1.16738 8.98636 1.33619C9.83503 1.505 10.6146 1.92168 11.2264 2.53353C11.8383 3.14539 12.255 3.92494 12.4238 4.77361C12.5926 5.62227 12.5059 6.50194 12.1748 7.30137C11.8437 8.10079 11.2829 8.78407 10.5635 9.2648C9.844 9.74554 8.99813 10.0021 8.13284 10.0021C6.9729 10.0009 5.86082 9.53955 5.04062 8.71935C4.22042 7.89915 3.75908 6.78707 3.75784 5.62713Z"
      fill="currentColor"
    />
  </svg>
);

/** From `public/images/Courses.svg` */
const CoursesIcon = ({ className = 'h-4 w-[18px] shrink-0' }) => (
  <svg className={className} viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M16.875 0H11.25C10.7649 0 10.2864 0.112953 9.85246 0.329915C9.41853 0.546877 9.04108 0.861887 8.75 1.25C8.45892 0.861887 8.08147 0.546877 7.64754 0.329915C7.21362 0.112953 6.73514 0 6.25 0H0.625C0.45924 0 0.300268 0.0658481 0.183058 0.183058C0.065848 0.300269 0 0.45924 0 0.625V11.875C0 12.0408 0.065848 12.1997 0.183058 12.3169C0.300268 12.4342 0.45924 12.5 0.625 12.5H6.25C6.74728 12.5 7.22419 12.6975 7.57583 13.0492C7.92746 13.4008 8.125 13.8777 8.125 14.375C8.125 14.5408 8.19085 14.6997 8.30806 14.8169C8.42527 14.9342 8.58424 15 8.75 15C8.91576 15 9.07473 14.9342 9.19194 14.8169C9.30915 14.6997 9.375 14.5408 9.375 14.375C9.375 13.8777 9.57254 13.4008 9.92417 13.0492C10.2758 12.6975 10.7527 12.5 11.25 12.5H16.875C17.0408 12.5 17.1997 12.4342 17.3169 12.3169C17.4342 12.1997 17.5 12.0408 17.5 11.875V0.625C17.5 0.45924 17.4342 0.300269 17.3169 0.183058C17.1997 0.0658481 17.0408 0 16.875 0ZM6.25 11.25H1.25V1.25H6.25C6.74728 1.25 7.22419 1.44754 7.57583 1.79917C7.92746 2.15081 8.125 2.62772 8.125 3.125V11.875C7.58458 11.4683 6.92633 11.2489 6.25 11.25ZM16.25 11.25H11.25C10.5737 11.2489 9.91542 11.4683 9.375 11.875V3.125C9.375 2.62772 9.57254 2.15081 9.92417 1.79917C10.2758 1.44754 10.7527 1.25 11.25 1.25H16.25V11.25Z"
      fill="currentColor"
    />
  </svg>
);

/** Matches `public/images/NewCourses.svg` — uses currentColor for NavLink states */
const NewCoursesIcon = ({ className = 'h-4 w-[19px] shrink-0' }) => (
  <svg className={className} viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M16.875 0H11.25C10.7649 0 10.2864 0.112953 9.85246 0.329915C9.41853 0.546877 9.04108 0.861887 8.75 1.25C8.45892 0.861887 8.08147 0.546877 7.64754 0.329915C7.21362 0.112953 6.73514 0 6.25 0H0.625C0.45924 0 0.300268 0.0658481 0.183058 0.183058C0.065848 0.300269 0 0.45924 0 0.625V11.875C0 12.0408 0.065848 12.1997 0.183058 12.3169C0.300268 12.4342 0.45924 12.5 0.625 12.5H6.25C6.74728 12.5 7.22419 12.6975 7.57583 13.0492C7.92746 13.4008 8.125 13.8777 8.125 14.375C8.125 14.5408 8.19085 14.6997 8.30806 14.8169C8.42527 14.9342 8.58424 15 8.75 15C8.91576 15 9.07473 14.9342 9.19194 14.8169C9.30915 14.6997 9.375 14.5408 9.375 14.375C9.375 13.8777 9.57254 13.4008 9.92417 13.0492C10.2758 12.6975 10.7527 12.5 11.25 12.5H16.875C17.0408 12.5 17.1997 12.4342 17.3169 12.3169C17.4342 12.1997 17.5 12.0408 17.5 11.875V0.625C17.5 0.45924 17.4342 0.300269 17.3169 0.183058C17.1997 0.0658481 17.0408 0 16.875 0ZM6.25 11.25H1.25V1.25H6.25C6.74728 1.25 7.22419 1.44754 7.57583 1.79917C7.92746 2.15081 8.125 2.62772 8.125 3.125V11.875C7.58458 11.4683 6.92633 11.2489 6.25 11.25ZM16.25 11.25H11.25C10.5737 11.2489 9.91542 11.4683 9.375 11.875V3.125C9.375 2.62772 9.57254 2.15081 9.92417 1.79917C10.2758 1.44754 10.7527 1.25 11.25 1.25H16.25V11.25ZM11.25 3.125H14.375C14.5408 3.125 14.6997 3.19085 14.8169 3.30806C14.9342 3.42527 15 3.58424 15 3.75C15 3.91576 14.9342 4.07473 14.8169 4.19194C14.6997 4.30915 14.5408 4.375 14.375 4.375H11.25C11.0842 4.375 10.9253 4.30915 10.8081 4.19194C10.6908 4.07473 10.625 3.91576 10.625 3.75C10.625 3.58424 10.6908 3.42527 10.8081 3.30806C10.9253 3.19085 11.0842 3.125 11.25 3.125ZM15 6.25C15 6.41576 14.9342 6.57473 14.8169 6.69194C14.6997 6.80915 14.5408 6.875 14.375 6.875H11.25C11.0842 6.875 10.9253 6.80915 10.8081 6.69194C10.6908 6.57473 10.625 6.41576 10.625 6.25C10.625 6.08424 10.6908 5.92527 10.8081 5.80806C10.9253 5.69085 11.0842 5.625 11.25 5.625H14.375C14.5408 5.625 14.6997 5.69085 14.8169 5.80806C14.9342 5.92527 15 6.08424 15 6.25ZM15 8.75C15 8.91576 14.9342 9.07473 14.8169 9.19194C14.6997 9.30915 14.5408 9.375 14.375 9.375H11.25C11.0842 9.375 10.9253 9.30915 10.8081 9.19194C10.6908 9.07473 10.625 8.91576 10.625 8.75C10.625 8.58424 10.6908 8.42527 10.8081 8.30806C10.9253 8.19085 11.0842 8.125 11.25 8.125H14.375C14.5408 8.125 14.6997 8.19085 14.8169 8.30806C14.9342 8.42527 15 8.58424 15 8.75Z"
      fill="currentColor"
    />
  </svg>
);

const BellIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 8a6 6 0 10-12 0c0 7-3 7-3 7h18s-3 0-3-7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.73 21a2 2 0 01-3.46 0"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SettingsIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 15.5a3.5 3.5 0 110-7 3.5 3.5 0 010 7z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.4 15a1.8 1.8 0 00.36 1.98l.05.05a2.2 2.2 0 01-1.55 3.75 2.2 2.2 0 01-1.56-.64l-.05-.05A1.8 1.8 0 0015 19.4a1.8 1.8 0 00-1 .33 1.8 1.8 0 00-.7 1.47V21a2.2 2.2 0 01-4.4 0v-.07a1.8 1.8 0 00-.7-1.46 1.8 1.8 0 00-1-.33 1.8 1.8 0 00-1.98.36l-.05.05A2.2 2.2 0 012.5 18a2.2 2.2 0 01.64-1.56l.05-.05A1.8 1.8 0 004.6 15a1.8 1.8 0 00-.33-1 1.8 1.8 0 00-1.47-.7H2.7a2.2 2.2 0 010-4.4h.07a1.8 1.8 0 001.46-.7 1.8 1.8 0 00.33-1 1.8 1.8 0 00-.36-1.98l-.05-.05A2.2 2.2 0 015 2.5a2.2 2.2 0 011.56.64l.05.05A1.8 1.8 0 009 4.6a1.8 1.8 0 001-.33 1.8 1.8 0 00.7-1.47V2.7a2.2 2.2 0 014.4 0v.07a1.8 1.8 0 00.7 1.46 1.8 1.8 0 001 .33 1.8 1.8 0 001.98-.36l.05-.05A2.2 2.2 0 0121.5 6a2.2 2.2 0 01-.64 1.56l-.05.05A1.8 1.8 0 0019.4 9c0 .35.11.69.33 1 .22.31.53.55.9.7.24.1.5.15.76.15H21.3a2.2 2.2 0 010 4.4h-.07a1.8 1.8 0 00-1.46.7 1.8 1.8 0 00-.33 1z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const mainItems = [
  { label: 'Dashboard', to: '/inst/dashboard', icon: <DashboardIcon /> },
  { label: 'Instructors', to: '/inst/instructors', icon: <InstructorIcon /> },
  { label: 'Courses', to: '/inst/courses', icon: <CoursesIcon /> },
  { label: 'Publish New Course', to: '/inst/publish', icon: <NewCoursesIcon /> },
];

const bottomItems = [
  { label: 'Notifications', to: '/inst/notifications', icon: <BellIcon /> },
  { label: 'Settings', to: '/inst/settings', icon: <SettingsIcon /> },
];

export default function Sidebaar() {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <>
      <div className="lg:hidden border-b border-[#E5E7EB] bg-white px-3 py-3">
        <div className="flex items-center justify-between gap-3">
          <img
            src={`${process.env.PUBLIC_URL}/images/llogo.png`}
            alt="AI Sanctuary"
            className="h-10 w-auto"
          />
          <button
            type="button"
            onClick={() => setIsMobileMenuOpen((open) => !open)}
            className="inline-flex items-center gap-2 rounded-lg border border-[#E5E7EB] px-3 py-2 text-xs font-semibold text-[#111827]"
            aria-expanded={isMobileMenuOpen}
            aria-label="Toggle instructor menu"
          >
            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
              <path d="M4 7h16M4 12h16M4 17h16" strokeLinecap="round" />
            </svg>
            Menu
          </button>
        </div>
        {isMobileMenuOpen ? (
          <div className="mt-3 rounded-xl border border-[#E5E7EB] bg-white p-2 shadow-sm">
            <nav className="space-y-1">
              {[...mainItems, ...bottomItems].map((item) => (
                <NavLink
                  key={`mobile-${item.label}`}
                  to={item.to}
                  className={({ isActive }) =>
                    [
                      'block rounded-lg px-3 py-2 text-sm',
                      isActive ? 'bg-[#E9F1FF] text-[#2563EB] font-medium' : 'text-[#111827] hover:bg-[#F3F4F6]',
                    ].join(' ')
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        ) : null}
      </div>

      <aside className="sticky top-0 hidden h-screen w-64 border-r border-[#E5E7EB] bg-white px-4 pb-6 pt-6 lg:flex lg:flex-col">
        <div className="mb-6 flex items-center justify-start px-1">
          <img
            src={`${process.env.PUBLIC_URL}/images/llogo.png`}
            alt="AI Sanctuary"
            className="h-16 w-auto max-w-[320px]"
          />
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto">
          <nav className="space-y-1 text-sm">
            {mainItems.map((item) => (
              <NavLink
                key={item.label}
                to={item.to}
                className={({ isActive }) =>
                  [
                    'flex items-center gap-2.5 px-3 py-2.5 rounded-xl cursor-pointer transition-colors',
                    isActive
                      ? 'bg-[#E9F1FF] text-[#2563EB] font-medium'
                      : 'text-[#111827] hover:bg-gray-100',
                  ].join(' ')
                }
              >
                <span className="shrink-0">{item.icon}</span>
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>
        </div>

        <div className="pt-6">
          <div className="h-px bg-[#E5E7EB] mb-4" />
          <nav className="space-y-1 text-sm">
            {bottomItems.map((item) => (
              <NavLink
                key={item.label}
                to={item.to}
                className={({ isActive }) =>
                  [
                    'flex items-center gap-2.5 px-3 py-2.5 rounded-xl cursor-pointer transition-colors',
                    isActive
                      ? 'bg-[#E9F1FF] text-[#2563EB] font-medium'
                      : 'text-[#111827] hover:bg-gray-100',
                  ].join(' ')
                }
              >
                <span className="shrink-0">{item.icon}</span>
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>
        </div>
      </aside>
    </>
  );
}

